"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GridColumn = /** @class */ (function (_super) {
    __extends(GridColumn, _super);
    function GridColumn(props) {
        var _this = _super.call(this, props) || this;
        _this.bindAll();
        return _this;
    }
    GridColumn.prototype.bindAll = function () {
        this.onClick = this.onClick.bind(this);
    };
    GridColumn.prototype.render = function () {
        var classes = this.itemClasses(this.props.options);
        var offsetClass = this.offsetClass(this.props.options);
        var customOptions = (this.props.options && this.props.options.customOptions ?
            this.props.options.customOptions : {});
        return (React.createElement(React.Fragment, null,
            this.props.options && this.props.options.offset &&
                React.createElement("div", { className: offsetClass.join(' ') }),
            React.createElement("div", __assign({ "data-test-id": this.props.testId, className: classes.join(' ') }, customOptions, { onClick: this.props.events && this.props.events.onClick ? this.onClick : null }), this.props.children)));
    };
    GridColumn.prototype.itemClasses = function (options) {
        var classnames = [];
        if (options && options.size) {
            classnames.push(["grid-col-" + options.size]);
        }
        if (options && options.sizeSM) {
            classnames.push(["grid-col-" + options.size + "-sm"]);
        }
        if (options && options.sizeMD) {
            classnames.push(["grid-col-" + options.size + "-md"]);
        }
        if (options && options.alignSelf) {
            classnames.push(["flex-self-" + options.alignSelf]);
        }
        if (options && options.alighItems) {
            classnames.push(["flex-items-" + options.alighItems]);
        }
        if (options && options.justifyContent) {
            classnames.push(["justify-" + options.justifyContent]);
        }
        if (options && options.className) {
            classnames.push(options.className);
        }
        return classnames;
    };
    GridColumn.prototype.offsetClass = function (options) {
        var offsetclass = [];
        if (options && options.offset) {
            offsetclass.push(["offset" + options.offset]);
        }
        if (options && options.offsetSM) {
            offsetclass.push(["offset" + options.offset + "-sm"]);
        }
        if (options && options.offsetSM) {
            offsetclass.push(["offset" + options.offset + "-md"]);
        }
        return offsetclass;
    };
    GridColumn.prototype.onClick = function () {
        if (this.props.events && this.props.events.onClick) {
            return this.props.events.onClick();
        }
    };
    return GridColumn;
}(React.Component));
exports.default = GridColumn;
//# sourceMappingURL=GridColumn.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Grid/GridColumn/GridColumn.js
// module id = 1358
// module chunks = 8